import { SyncFetch } from "src/app/models/sync.model";
import { SyncRealDataJob } from "./AbstractSyncRealDataJob";


export class SyncRefundJob extends SyncRealDataJob {


    override async clean(): Promise<void> {
        await this.db.clear("returns")
         
    }

    async save(r: SyncFetch) {



        const add = r.items.filter(a => a.returnData && a.state === 1).map(a => a.returnData!.returnData);
        const del = r.items.filter(a => a.returnData && a.state === 2).map(a => a.id);


        await this.db.deleteArray('returns', del);

        add.forEach(p => {
            if (!(p.date instanceof Date)) {
                p.date = new Date(Date.parse(p.date))
            }
            if (p.dateDelivery && !(p.dateDelivery instanceof Date)) {
                p.dateDelivery = new Date(Date.parse(p.dateDelivery))
            }
            
        });

        await this.db.addArray('returns', add);

    }

}
